import Component, { register } from '@services/component'
import { find, toggleClass, style } from '@services/dom'
import anime from 'animejs'

let wasShown = false;

export default register(
    class PageIntro extends Component {
        static selector = '#page-intro'

        create() {
            toggleClass(document.documentElement, 'init', true);
            if (wasShown) {
                toggleClass(document.documentElement, 'no-intro', true);
                return;
            }
            wasShown = true;
            const [logo] = find('.logo', this.el);
            // const [lines] = find('.lines', this.el);
            // const [organics] = find('.organics', this.el);
            // const [letters] = find('.letters', this.el);

            this.animate(logo, /*lines, organics, letters*/);
        }

        animate(logo, lines, organics, letters) {
            // style([organics], { opacity: 0 });
            const speed = 1;
            const time = t => t * speed;

            anime({
                targets: logo,
                //translateY:["-25%","0%"],
                scaleY: [2, 1],
                scaleX: [2, 1],
                opacity: [0, 1],
                duration: time(1000),
                easing: 'easeOutQuint',
                delay: time(100)
            });

            // anime({
            //     targets:organics,
            //     opacity:[0,1],
            //     scaleY:[.5,1],
            //     scaleX:[.5,1],
            //     duration:time(1000),
            //     easing:'easeOutQuint',
            //     delay:time(250)
            // });

            // anime({
            //     targets:lines,
            //     opacity:[.5,1],
            //     duration:time(250),
            //     easing:'easeOutQuint',
            //     delay:time(1000)
            // });

            anime({
                targets: this.el,
                duration: 500,
                translateY: ['0%', '-100%'],
                easing: 'easeInOutQuint',
                delay: time(2000),
                complete() {
                    toggleClass(document.documentElement, 'no-intro', true);
                }
            });
        }
    }
);